module.exports = __webpack_public_path__ + "static/media/left-arrow.a3b1f925.svg";